import { ReactNode, useCallback, useState } from 'react'

import { lazyRenderWidget } from 'core-components/helpers/lazyLoad'
import { Button } from 'core-components/library/button'
import { Flex } from 'core-components/library/flex'
import { ModalDialog } from 'core-components/library/modalDialog'

interface ITooltipButtonWrapper {
  children: ReactNode
  modalPath?: string
}

export const TooltipButtonWrapper = ({ children, modalPath }: ITooltipButtonWrapper) => {
  const [modalVisible, setModalVisible] = useState<boolean>(false)

  const content = useCallback(() => {
    const lazyContent = modalPath ? lazyRenderWidget(modalPath, {}) : null
    if (!modalPath || !lazyContent) {
      return <div>Can't load template</div>
    }

    return lazyContent
  }, [modalPath])

  if (!modalPath) {
    return <>{children}</>
  }

  return (
    <Flex>
      {children}
      <Button
        iconButton={'kbase kbase-question'}
        variant={'outlined'}
        onClick={() => setModalVisible(true)}
      />
      <ModalDialog
        show={modalVisible}
        size={'auto'}
        onClose={() => setModalVisible(false)}
        content={content}
      />
    </Flex>
  )
}
